var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDisconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10369_9353)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.65055 13.3012H4.51404C2.61031 13.3012 1.6626 12.3534 1.6626 10.4497V4.51404C1.6626 2.61031 2.61031 1.6626 4.51404 1.6626H8.3132C10.2169 1.6626 11.1646 2.61031 11.1646 4.51404",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4377 18.2892H11.6386C9.73482 18.2892 8.78711 17.3415 8.78711 15.4377V9.50208C8.78711 7.59835 9.73482 6.65063 11.6386 6.65063H15.4377C17.3414 6.65063 18.2892 7.59835 18.2892 9.50208V15.4377C18.2892 17.3415 17.3414 18.2892 15.4377 18.2892Z",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3608 12.4697H15.071",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10369_9353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9518,
    height: 19.9518,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDisconnect);
export default __webpack_public_path__ + "static/media/menuDisconnect.8a660bdc649586564aabcb1bd8437fca.svg";
export { ForwardRef as ReactComponent };